<script>
    import BaseButton from './common/BaseButton.svelte'
    export let description
    export let button
</script>

<div class="bg-navy rounded-md p-8 md:p-16 text-white text-center drop-shadow-lg">
    <slot name="icon" />
    <p class="font-light mb-8">{@html description}</p>
    <BaseButton on:click>{button}</BaseButton>
</div>